import React from 'react';

import CatalogShell from './CatalogShell';

const TaskTypes: React.FC = () => (
  <CatalogShell
    slug="task-types"
    title="Task types"
    breadcrumbLabel="Task types"
    emptyBody="Task types are the FK parent for config.task.task_type_code. Tasks can't be created until at least one exists."
    addCtaLabel="Add first task type"
  />
);

export default TaskTypes;
